module.exports = __webpack_public_path__ + "static/media/logo165x90white.89ec5664.png";